import React from 'react'
import { useSelector } from 'react-redux'
import { selectIsUserAccountEnabled } from '../../store/userAccount/userAccount.selectors'
import { AddressFavoriteButton } from '../UserAccount/connected/userFavorites/FavoriteButton'
import AddressCoordinates from './AddressCoordinates'
import AddressDescription from './AddressDescription'
import AddressShareButton from './AddressShareButton'
import s from './AddressContent.less'
import sLocationButtons from '../location/LocationHeaderButtons.less'
import { TAG_GOTO } from '../analytics/analytics.tagids.constants'
import LocationItineraryButton from '../location/LocationItineraryButton'
import classNames from 'classnames'
import pccLogo from '../genericComponents/assets/logo-pcc.webp'
import { selectCmsIsPetiteCiteDeCaractere } from '../../store/seo/seo.selectors'
import { PAGE_ADDRESS_NAME } from '../analytics/pageTags.constants'

const AddressContent = ({ address }) => {
  const { split_label } = address
  const shouldDisplayFavoriteButton = useSelector(selectIsUserAccountEnabled)
  const isPetiteCiteDeCaractere = useSelector(selectCmsIsPetiteCiteDeCaractere)

  return (
    <div className={s.addressContent}>
      <div className={s.mainHeader}>
        <div className={s.headerLeft}>
          <div className={s.addressInfo}>
            <h1 className={s.addressTitle}>
              <span className={s.locationMainAddress}>{split_label?.[0]} </span>
              {split_label?.slice(1).map((line) => (
                <span className={s.locationSubAddress} key={line}>
                  {line}
                </span>
              ))}
            </h1>
            <AddressCoordinates address={address} />
          </div>
          {isPetiteCiteDeCaractere && <img src={pccLogo} alt="Petite Cité de Caractère" className={s.pccLogo} />}
        </div>
        <div className={classNames(s.actions, sLocationButtons.buttonsSection)}>
          <div className={sLocationButtons.buttonList}>
            <LocationItineraryButton
              location={address}
              tagProps={{
                type: TAG_GOTO,
                tagInfo: {
                  ancrage: PAGE_ADDRESS_NAME,
                },
              }}
            />
            <AddressShareButton />
            {shouldDisplayFavoriteButton && <AddressFavoriteButton />}
          </div>
        </div>
      </div>
      <AddressDescription />
    </div>
  )
}

export default AddressContent
